import React, { useState } from "react";
import "./nav.css";
import logo from "../../assets/images/logo.png";
import { GiHamburgerMenu } from "react-icons/gi";
import { AiOutlineClose } from "react-icons/ai";

const Nav = () => {
  const [showNavbar, setShowNavbar] = useState(false);

  return (
    <nav className="navbar-main">
      <div className="logo">
        <a href="/">
          <img src={logo} alt="Logo" />
        </a>
      </div>
      <div
        onClick={() => {
          setShowNavbar(true);
        }}
        className={!showNavbar ? "toggle-open" : "hide"}
      >
        <GiHamburgerMenu size={24} />
      </div>
      <ul className={showNavbar ? "links active" : "links"}>
        <li>
          <div
            className="toggle-close"
            onClick={() => {
              setShowNavbar(false);
            }}
          >
            <AiOutlineClose color="white" size={24} />
          </div>
        </li>
        <li>
          <a href="#works">How it works</a>
        </li>
        <li>
          <a href="#roadmap">Roadmap</a>
        </li>
        <li>
          <a href="#tokonomics">Tokonomics</a>
        </li>
        <li>
          {/* <a href="https://loopofinfinitydex.netlify.app/dex">LoopSwap</a> */}
          <a href="/dexx">LoopSwap</a>
        </li>
        <li>
          <a
            href="https://www.dropbox.com/scl/fi/ep16tithf2qexz10twyee/LOOP-OF-INFINITY-WHITEPAPER-April-Update.pdf?rlkey=a1i8hvzn9ncrhcsqfdtskfpxl&dl=0"
            target="_blank"
          >
            White Paper
          </a>
        </li>
        <li>
          <a href="/staking-dashboard">Stake</a>
        </li>
      </ul>
    </nav>
  );
};

export default Nav;
